import { ChevronLeft, ChevronRight } from "lucide-react";

/** Janela de páginas ao redor da atual, com "…" nos saltos. */
function pageWindow(page, lastPage, span = 1) {
  const out = [];
  for (let i = 1; i <= lastPage; i += 1) {
    const near = Math.abs(i - page) <= span;
    if (i === 1 || i === lastPage || near) out.push(i);
    else if (out[out.length - 1] !== "…") out.push("…");
  }
  return out;
}

/**
 * Paginação numerada das telas do painel.
 * Some os botões quando há uma página só, mas mantém a contagem visível.
 */
export default function Pagination({ page, lastPage, total, perPage = 25, onChange, label = "registros" }) {
  // Sem resultado, quem fala é o EmptyState da tabela — que ainda oferece a
  // saída ("Limpar filtros", "Cadastrar o primeiro"). Repetir "Nenhum resultado
  // encontrado" logo abaixo só duplica a má notícia.
  if (!total) return null;

  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);
  const btn = "min-w-[34px] h-[34px] px-2 rounded-lg border text-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

  return (
    <div className="flex items-center justify-between flex-wrap gap-3 pt-3" data-testid="pagination">
      <p className="text-xs text-slate-500" data-testid="pagination-summary">
        {`Mostrando ${from}–${to} de ${total} ${label}`}
      </p>
      {lastPage > 1 && (
        <div className="flex items-center gap-1">
          <button type="button" onClick={() => onChange(page - 1)} disabled={page <= 1}
            aria-label="Página anterior" data-testid="pagination-prev"
            className={`${btn} border-slate-200 text-slate-600 hover:border-brand-500 hover:text-brand-600 flex items-center justify-center`}>
            <ChevronLeft size={15} />
          </button>
          {pageWindow(page, lastPage).map((p, i) => (
            p === "…" ? (
              <span key={`gap-${i}`} className="px-1 text-slate-400 text-sm">…</span>
            ) : (
              <button key={p} type="button" onClick={() => onChange(p)} data-testid={`pagination-page-${p}`}
                aria-current={p === page ? "page" : undefined}
                className={`${btn} ${p === page
                  ? "border-brand-600 bg-brand-600 text-white font-semibold"
                  : "border-slate-200 text-slate-600 hover:border-brand-500 hover:text-brand-600"}`}>
                {p}
              </button>
            )
          ))}
          <button type="button" onClick={() => onChange(page + 1)} disabled={page >= lastPage}
            aria-label="Próxima página" data-testid="pagination-next"
            className={`${btn} border-slate-200 text-slate-600 hover:border-brand-500 hover:text-brand-600 flex items-center justify-center`}>
            <ChevronRight size={15} />
          </button>
        </div>
      )}
    </div>
  );
}
